var r,o,n;o=r||(r={}),n=function(r){return r.Info="Info",r.Error="Error",r}({}),o.ToastType=n;export{r as ToastModel};
//# sourceMappingURL=ToastModel.js.map
